module.exports = __webpack_public_path__ + "fonts/TTMarxiana-Antiqua.014e9098.eot";